(function($){
  var whatsupSlider = {
    init: function(){
      if ($('.whatsup-slider').length){
        whatsupSlider.initWhatsupSlider();
      }
    },
    initWhatsupSlider: function(){

      $('.whatsup-slider').flickity({
        prevNextButtons: false,
        autoPlay: 3000,
        wrapAround: true,
        cellAlign: 'center',
        watchCSS: true,
      });

    }
  };
  $(document).ready(whatsupSlider.init);
})(jQuery);
